<template>
    <div>
        <webix-ui :config="webixUI"/>
    </div>
</template>

<script>
    import app from '$$app';
    import VuePage from "./VuePage.vue";
    import webixWindowForVueSample from "./webixWindowForVueSample";

    export default {
        name: 'VuePageSample',
        props: [],
        data() {
            return {
            }
        },
        created: function() {
            this.webixUI = webixWindowForVueSample.window("vueSampleWindowId", VuePage, {
                borderless: true
            });
        },
        mounted: function() {
            let component = this;
            component.$nextTick(function () {
                $$("vueSampleWindowId").show();
            })
        }
    }
</script>


<style scoped>

</style>
